import { create } from 'client/helpers/axios';
import config from 'client/config';
import parseErrorMessage from '../../helpers/parseErrorMessage';

const repository = {
    axios: create({ baseUrl: '/location' }),

    async createRecaptchaToken() {
        let tokenResult = null;
        if (window.grecaptcha) {
            tokenResult = await window.grecaptcha.enterprise
                .execute(config.googleRecaptchaKey, {
                    action: 'submit',
                })
                .then(token => token);

            return tokenResult;
        } else {
            throw new Error('Recaptcha loading failed. Please try again later');
        }
    },

    async searchForAddressSuggestions(params) {
        const recaptchaToken = await this.createRecaptchaToken();
        try {
            const response = await this.axios.post(`/address/search`, {
                ...params,
                recaptchaToken,
            });
            return response?.data;
        } catch (error) {
            const message = parseErrorMessage(error);
            throw new Error(message);
        }
    },

    async selectAddressForAutocomplete(params) {
        const recaptchaToken = await this.createRecaptchaToken();
        try {
            const response = await this.axios.post(`/address/select`, {
                ...params,
                recaptchaToken,
            });
            return response?.data;
        } catch (error) {
            const message = parseErrorMessage(error);
            throw new Error(message);
        }
    },
};

export default repository;
